import API from '@/services';
import { initStore } from '@/stores';

const suggestionIntentNumber = 1;
const typingSuggestionIntentNumber = 5;

const refreshIntentTimeout = 2 * 1000;

enum LandingPagePredictScene {
  DefaultSuggestion = 1,
  IntentPrediction = 2,
}

export function refreshInputBoxSuggestionIntent() {
  initStore.UPDATE_INPUT_BOX_SUGGESTION_INTENT(null);

  setTimeout(async () => {
    const res = await (API as any)
      .getLandingPagePredict({ session_id: initStore.sessionId, num: suggestionIntentNumber, scene: LandingPagePredictScene.DefaultSuggestion })
      .catch(() => {});

    initStore.UPDATE_INPUT_BOX_SUGGESTION_INTENT({ intent: res.intents?.[0] ?? null, requestId: res.request_id });
  }, refreshIntentTimeout);
}

interface LandingPagePredictResponse {
  intents: {
    intent_id: number
    intent_name: string
    category_name?: string
    intent_type?: number
    intent_source?: number
    hotquestion_text: string
    shortcut_text: string
    query_callback: {
      source?: number
      session_id?: string
      intent_id?: number
    }
  }[];
  request_id: string;
}
export async function getTypingSuggestionIntents() {
  const res = await (API as {
    getLandingPagePredict(params: {session_id: string; num: number; scene: LandingPagePredictScene}): Promise<LandingPagePredictResponse>;
  })
    .getLandingPagePredict({ session_id: initStore.sessionId, num: typingSuggestionIntentNumber, scene: LandingPagePredictScene.IntentPrediction })
    .catch(() => {});
  return res;
}
